// Simulate `user-select: contain`.
const containSelection = (container: HTMLElement) => {
  // Inspired by
  // https://github.com/github/user-select-contain-polyfill/blob/main/user-select-contain.js#L17
  const selection = window.getSelection();
  if (!selection?.rangeCount) return;

  const range = selection.getRangeAt(0);
  if (
    container.contains(range.commonAncestorContainer) ||
    // Make sure as least one end of the range is inside the cell.
    // This is needed because other (click/mouseup) event handlers
    // may have already moved the selection (e.g. to comment input).
    !(
      container.contains(range.startContainer) ||
      container.contains(range.endContainer)
    )
  ) {
    return;
  }

  selection.selectAllChildren(container);
};

export default containSelection;
